import React, {useContext, useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import { Button, SubTitle, Spacer, Toggle, Dropdown, Text } from "@dspworkplace/ui";
import { useAuth } from "../../../Auth";
import SettingsContext from "../context";
import { getCompanyId, showToast } from "../../../Utilities";
import WorkHourComplianceNotifyUsers from "./WorkHourComplianceNotifyUsers";
import { AccessCheck, IsGranted } from "../../../security";
import Modal from "../../../components/Modal";
import { HelpButton } from "../../../components/UI";

async function updateWorkHourComplianceNotifyUsers(api, workHourComplianceNotifyUsers) {
    try {
        await api.post('/api/bot/twilio/employees', {
            companyId: getCompanyId(),
            update: 'workHourComplianceNotifyUsers',
            workHourComplianceNotifyUsers,
        });
        return true
    } catch (e) {
        return false;
    }
}
const generateTimeOptions = (max) => 
    Array.from({ length: max }, (_, i) => {
      const value = i.toString().padStart(2, '0');
      return { name: value, value };
    });
    

const WorkHourComplianceWarning = () => {
    const { register, handleSubmit, watch, reset} = useForm();
    const { api } = useAuth();
    const [state, dispatch] = useContext(SettingsContext);
    const workHourComplianceWarning = watch("workHourComplianceWarning");
    const [showHelp, setShowHelp] = useState(false);

    const optionHours = generateTimeOptions(24);
    const optionMinutes = generateTimeOptions(60);

    useEffect(() => {
        const workHourComplianceWarningTimePeriod = (state.company.workHourComplianceWarningTimePeriod ? (state.company.workHourComplianceWarningTimePeriod):"").split(":");
        reset({
            "workHourComplianceWarning" : state.company.workHourComplianceWarning, 
            "workHourComplianceTimeHour" : workHourComplianceWarningTimePeriod[0],
            "workHourComplianceTimeMinute" : workHourComplianceWarningTimePeriod[1]
        });
    }, [state.company]);

    const onSubmit = async (data, evt) => {
        let form = evt.target;
        try {
            form.querySelector('button').disabled = true;
            if(data?.workHourComplianceNotifyUsers?.length == 0){
                data.workHourComplianceNotifyUsers = null;
            }
            let updateRecord = { 
                workHourComplianceWarning: data.workHourComplianceWarning,
                ...(data.workHourComplianceWarning && {workHourComplianceWarningTimePeriod: data.workHourComplianceTimeHour+':'+data.workHourComplianceTimeMinute})
            };
            await api.post('/api/lazy/manage/data', {
                actions: {
                    update: {
                        Company: {
                            update_company: {
                                findBy: {
                                    id: getCompanyId()
                                },
                                updateRecord: updateRecord
                            }
                        }
                    }
                }
            });
            if(data.workHourComplianceWarning == true){
                await updateWorkHourComplianceNotifyUsers(api, data.workHourComplianceNotifyUsers);
                updateRecord = { 
                    ...updateRecord,
                    ...{workHourComplianceNotifyUsers: data.workHourComplianceNotifyUsers}
                };
            }
            await showToast({
                type: 'success',
                title: 'Enable Work Hour Compliance Warning',
                content: 'Updates completed'
            });
            form.querySelector('button').disabled = false;
            dispatch({type: 'UPDATE_COMPANY', payload: {company: {...state.company, ...updateRecord}}})
        } catch (e) {
            await showToast({ type: 'error', title: 'Enable Work Hour Compliance Warning', content: JSON.stringify(e) });
            form.querySelector('button').disabled = false;
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <SubTitle>
                Enable Work Hour Compliance Warning
                <HelpButton onClick={() => setShowHelp(true)}>How Does It Work?</HelpButton>
            </SubTitle>
            <Spacer bottom={2} />
            <Toggle
                ref={register}
                name="workHourComplianceWarning"
                singleText="Send notification HH:MM after Flex login"
                on={workHourComplianceWarning}
            />
            {workHourComplianceWarning && (
                <Spacer top={4}>
                    <label
                        style={{
                            fontSize: "16px",
                            fontWeight: "normal",
                            fontFamily: "Circe-Rounded",
                            display: "block",
                            paddingBottom: "2px",
                            color: "#707070",
                        }}
                    >
                        Time period
                    </label>
                    <Dropdown
                        name='workHourComplianceTimeHour'
                        label='Hour'
                        ref={register}
                        placeholder='Hour'
                        options={optionHours}
                    style={{marginRight:'5px',fontSize: "12px"}}
                    size='extraSmall'
                        valid={"true"}
                    />
                    <Dropdown
                    name='workHourComplianceTimeMinute'
                        ref={register}
                        label='Minute'
                        placeholder='Minute'
                        options={optionMinutes}
                        style={{}}
                    size='extraSmall'
                        valid={"true"}
                    />
                    <Spacer bottom={5} />
                    <WorkHourComplianceNotifyUsers ref={register} />
                </Spacer>
            )}
            <IsGranted feature={AccessCheck.features.SETTINGS} ops={[AccessCheck.OPS.U]}>
                <Spacer bottom={5} />
                <Button type='primary'>Save</Button>
            </IsGranted>
            {!showHelp ? null : (
                <Modal
                    visible={true}
                    setVisible={() => setShowHelp(false)}
                    title={"Work Hours Compliance Warning"}
                    drawer={"right"}
                >
                    <Text>
                        This will send a workbot alert for any employee who has not punched out in the set time period after their Flex Login. For this setting to work, the employee must have both the Flex login time (via RouteAssist) and a punch out (via payroll integration).
                    </Text>
                    <Spacer bottom={5} />
                </Modal>
            )}
        </form>
    );
}

export default WorkHourComplianceWarning;